/** ----------------------------------------
    Imports
---------------------------------------- */

import { RouterHelper as BaseRouterHelper } from '@fruitpackage/helpers';
import store from '@store/store';

/** ----------------------------------------
    Generator helper
---------------------------------------- */

export default class RouterHelper extends BaseRouterHelper {
    
    /**
     * @param  {[object]} router
     * @param  {string} path
     * @param  {boolean} authorized
     */
    static isAuthorized(router: [object], path: string) {
        const resolved = router.resolve(path);
        const to = resolved.resolved;
        const user = store.state.user;

        if (to.meta.reqAuth && !user.token)
            return false;
    
        if (to.meta.reqAuth && to.meta.authLevel && user.token && to.meta.authLevel < user.authLevel)
            return false;
    
        if (to.meta.reqUnauth && user.token)
            return false;
    
        return true;
    }
}